<script setup lang="ts">
import type { DeviceModel } from '@/types/models/DeviceModel'
import { StackLayout, TypographyItem } from '@rfc/rfc-components-library'
import { EColors } from '@rfc/rfc-components-library/types'
import { useI18n } from 'vue-i18n'

type Props = {
    data?: DeviceModel
}
const props = defineProps<Props>()

const { t } = useI18n()

const keys = ['f1', 'f2']

const formatEIDString = (key: string) =>
    `EID : ${props.data?.config?.[`${key}_evt_en`] ? (props.data?.config?.[`${key}_evt_val`] ?? t('common.undefined')) : '-'}`

const formatTIDString = (key: string) =>
    `TID : ${props.data?.config?.[`${key}_tmr_en`] ? (props.data?.config?.[`${key}_tmr_val`] ?? t('common.undefined')) : '-'}`
</script>

<template>
    <StackLayout direction="column">
        <StackLayout v-for="(filter, key) in keys" :key="key">
            <StackLayout direction="row" :gap="4">
                <TypographyItem :label="`${filter.toUpperCase()} :`" />
                <TypographyItem
                    :label="formatEIDString(filter)"
                    :color="
                        data?.config?.[`${filter}_evt_en`] ? EColors.SUCCESS : EColors.DANGER
                    " />
                <TypographyItem
                    :label="formatTIDString(filter)"
                    :color="
                        data?.config?.[`${filter}_tmr_en`] ? EColors.SUCCESS : EColors.DANGER
                    " />
            </StackLayout>
        </StackLayout>
    </StackLayout>
</template>
